import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEvents } from '../contexts/EventContext';
import { PRIMARY } from './legacy-ball/table-management/designTokens';

/**
 * Persistent "you are working inside Event X" bar shown at the top of every
 * hub page when an event is selected. Keeps the operator oriented no matter
 * which page (Guests / Seating / Orders / …) they navigate to, with a quick
 * way back to the portfolio.
 *
 * Rendered by AppLayout only for customer-tier roles with an event in scope.
 */
export function EventContextBar() {
  const { selectedEvent, selectEvent } = useEvents();
  const navigate = useNavigate();
  if (!selectedEvent) return null;

  const status = selectedEvent.status || 'Live';
  const statusStyle =
    status === 'Archived' ? styles.pillArchived
    : status === 'Draft' ? styles.pillDraft
    : styles.pillLive;

  return (
    <div style={styles.bar}>
      <div style={styles.left}>
        <span style={styles.icon} aria-hidden>🗓️</span>
        <span style={styles.label}>Working on</span>
        <span style={styles.name}>{selectedEvent.name}</span>
        {selectedEvent.venue?.name && (
          <span style={styles.venue}>· 📍 {selectedEvent.venue.name}</span>
        )}
        {selectedEvent.roomName && (
          <span style={styles.venue}>· 🚪 {selectedEvent.roomName}</span>
        )}
        <span style={{ ...styles.pill, ...statusStyle }}>{status}</span>
      </div>
      <button
        type="button"
        style={styles.allBtn}
        onClick={() => { selectEvent(null); navigate('/dashboard'); }}
        title="Back to all events"
      >
        ← All events
      </button>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    position: 'sticky',
    top: 0,
    zIndex: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '8px 20px',
    backgroundColor: '#ecf5ef',
    borderBottom: `2px solid ${PRIMARY}`,
    flexWrap: 'wrap',
  },
  left: { display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, flexWrap: 'wrap' },
  icon: { fontSize: '15px', flexShrink: 0 },
  label: { fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#5a7a66', fontWeight: 700 },
  name: { fontSize: '0.95rem', fontWeight: 700, color: '#0f2d1f', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  venue: { fontSize: '0.82rem', color: '#5a7a66' },
  pill: { fontSize: '0.62rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', padding: '2px 8px', borderRadius: '10px' },
  pillLive: { color: PRIMARY, backgroundColor: '#d6eade' },
  pillDraft: { color: '#8a6d00', backgroundColor: '#fdf3d4' },
  pillArchived: { color: '#555', backgroundColor: '#e0e0e0' },
  allBtn: {
    background: 'none',
    border: `1px solid ${PRIMARY}`,
    color: PRIMARY,
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    padding: '5px 12px',
    borderRadius: '6px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
};
